<template>
  <div>
    <v-app>
      <!-- <v-main> -->
      <router-view class="d-none d-sm-flex" />
      <div class="text-center d-sm-none py-16">Mobile view does't support</div>
      <!-- </v-main> -->
    </v-app>
  </div>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    
  }),
};
</script>